import { VStack, Flex, Button, Text } from '@cad-arc';
import { observer } from 'mobx-react-lite';
import { useApplicationType } from '../../common/hooks/use-application-type';
import { useDexResults } from './use-dex-results';
import { useClearDexResultsMutation } from './use-clear-dex-results-mutation';

export const DexResultsLeftPaneFrControls = observer(function DexResultsLeftPaneFrControls() {
    const { isFirstResponder } = useApplicationType();
    const { dexResultsStore } = useDexResults();
    const clearResultsMutation = useClearDexResultsMutation();

    const hasResults = !!dexResultsStore.dexResultsViews?.length;
    if (!isFirstResponder) return null;

    return (
        <>
            <Button
                leadingVisual="DataExchangeInquiries"
                style={{ width: '100%', minHeight: '40px' }}
                variant="outline"
                isActive={dexResultsStore.frDexPageViewMode === 'NEW_FORM'}
                onClick={() => dexResultsStore.setFrDexPageViewMode('NEW_FORM')}
            >
                New Search
            </Button>
            {!hasResults && (
                <VStack paddingTop="5rem">
                    <Text variant="headingSm">No Returns</Text>
                    <Text variant="bodyMd" color="tertiary">
                        Send a query to view returns
                    </Text>
                </VStack>
            )}
            {hasResults && (
                <Flex justifyContent="flex-end" width="100%">
                    <Button variant="ghost" onClick={() => clearResultsMutation.mutate()}>
                        Clear All
                    </Button>
                </Flex>
            )}
        </>
    );
});
